import { render, staticRenderFns } from "./add-list-modal.vue?vue&type=template&id=625e48ae&scoped=true&lang=pug&"
import script from "./add-list-modal.vue?vue&type=script&lang=js&"
export * from "./add-list-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-list-modal.vue?vue&type=style&index=0&id=625e48ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e48ae",
  null
  
)

export default component.exports